import React, { useContext } from 'react';
import { DatePicker, Modal, Text } from 'v3/components';
import { Col, Row } from 'react-bootstrap';
import { capitalizeFullname, formatDateTime, formatAddress } from 'v3/utils/formatter';
import { BsPencil } from 'react-icons/bs';
import {
  Body as BodyAditionalFieldModal,
  Footer as FooterAditionalFieldModal,
  Heading as HeadingAditionalFieldModal,
} from 'components/ModalOccurenceAditionalFields';
import { OccurrencesAditionalFieldsContext } from 'contexts/OccurrencesAditionalFields';
import InputCurrency from 'v3/components/Input/Currency/index';
import { formatCurrency } from 'utils/formatter';
import { SectionContainer } from '../../styles';
import {
  DetailsContainer,
  HeaderContainer,
  PendencyLabel,
  StyledDetailCol,
  TitleContainer,
} from '../styles';
import OccurencesAditionalFieldsContainer from './OccurencesAditionalFieldsContainer';
import { AditionalFIeldsContainer, StyledButton } from './style';

export function OccurrenceGeneralInfo({
  selectedOccurrence,
  show,
  startDate,
  setStartDate,
  setEndDate,
  endDate,
  errors,
  loadingUpdate,
  savingNewOccurrence,
  occurrenceValues,
  setOccurrenceValues,
}) {
  const { aditionalItensModal, handleCloseModal } = useContext(OccurrencesAditionalFieldsContext);
  const destination = selectedOccurrence?.occurrenceClientFields?.loadsDestinations;
  return (
    <>
      <SectionContainer>
        <HeaderContainer>
          <TitleContainer>
            <Text weight={500} type="header" color="dark">
              Informações da Ocorrência
            </Text>
            {selectedOccurrence?.pendency &&
              !selectedOccurrence?.fullUserConclusion?.username &&
              !selectedOccurrence?.annulled && <PendencyLabel>Pendente</PendencyLabel>}
          </TitleContainer>
          {selectedOccurrence?.pendency &&
            !selectedOccurrence?.fullUserConclusion?.username &&
            !selectedOccurrence?.fullUserConclusion?.id &&
            !selectedOccurrence?.annulled && (
              <StyledButton
                $backgroundColor="transparent"
                $color="#464e5f"
                onClick={aditionalItensModal.open}
                style={{ display: 'flex', gap: 8, alignItems: 'center' }}
              >
                <BsPencil /> Gestão de itens
              </StyledButton>
            )}
        </HeaderContainer>
        <DetailsContainer>
          <Row>
            <Col xxl={8} xl={7} lg={7} md={7} sm={12} xs={12}>
              <Row>
                <Col xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Data inclusão:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {formatDateTime(selectedOccurrence.createdAt)}
                  </Text>
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Tipo:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {selectedOccurrence.fullOccurrenceType.name}
                  </Text>
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Motivo:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {selectedOccurrence?.occurrenceTypeSecondary
                      ? capitalizeFullname(selectedOccurrence?.occurrenceTypeSecondary?.name)
                      : 'Não informado'}
                  </Text>
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Incluido por:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {capitalizeFullname(selectedOccurrence.fullUserCreated.username)}
                  </Text>
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Grupo Responsável:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {selectedOccurrence?.groups.length > 0
                      ? selectedOccurrence?.groups.map((g) => capitalizeFullname(g.name)).join(', ')
                      : capitalizeFullname(selectedOccurrence?.group?.name)}
                  </Text>
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Cliente Visualiza:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {selectedOccurrence.displayClient ? 'Sim' : 'Não'}
                  </Text>
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  <Text type="regular" color="dark" weight={500}>
                    Nº ocorrência cliente:{' '}
                  </Text>
                  <Text type="regular" color="dark" weight={400}>
                    {selectedOccurrence?.customerNumber
                      ? selectedOccurrence?.customerNumber
                      : 'Não informado'}
                  </Text>
                </Col>
                {['FIRST_DELIVERY_ATTEMPT', 'SECOND_DELIVERY_ATTEMPT'].includes(
                  selectedOccurrence?.fullOccurrenceType?.slug
                ) && selectedOccurrence?.occurrenceClientFields?.nextDeliveryDate && (
                  <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                    <Text type="regular" color="dark" weight={500}>
                      Próxima data de entrega:{' '}
                    </Text>
                    <Text type="regular" color="dark" weight={400}>
                      {formatDateTime(selectedOccurrence.occurrenceClientFields.nextDeliveryDate)}
                    </Text>
                  </Col>
                )}
                {
                  selectedOccurrence?.occurrenceClientFields && (
                    <>
                      {
                        selectedOccurrence?.fullOccurrenceType?.slug === 'DELIVERY' && (
                          <>
                            <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                              <Text type="regular" color="dark" weight={500}>
                                Nome do recebedor:{' '}
                              </Text>
                              <Text type="regular" color="dark" weight={400}>
                                {selectedOccurrence?.occurrenceClientFields?.receiverName}
                              </Text>
                            </Col>
                            <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                              <Text type="regular" color="dark" weight={500}>
                                Documento do recebedor:{' '}
                              </Text>
                              <Text type="regular" color="dark" weight={400}>
                                {selectedOccurrence?.occurrenceClientFields?.receiverDocument}
                              </Text>
                            </Col>
                            <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                              <Text type="regular" color="dark" weight={500}>
                                Tipo do recebedor:{' '}
                              </Text>
                              <Text type="regular" color="dark" weight={400}>
                                {selectedOccurrence?.occurrenceClientFields?.receiverType?.name}
                              </Text>
                            </Col>
                          </>
                        )
                      }
                      <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                        <Text type="regular" color="dark" weight={500}>
                          Documento:{' '}
                        </Text>
                        <Text type="regular" color="dark" weight={400}>
                          {selectedOccurrence?.occurrenceClientFields?.loadEmitted?.docType} - {selectedOccurrence?.occurrenceClientFields?.loadEmitted?.cteNumber}
                        </Text>
                      </Col>
                      <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                        <Text type="regular" color="dark" weight={500}>
                          NF-e:{' '}
                        </Text>
                        <Text type="regular" color="dark" weight={400}>
                          {selectedOccurrence?.loadNfs?.map(nf => nf?.nfNumber).join(', ')}
                        </Text>
                      </Col>
                      <Col xxl={8} lg={8} md={8} sm={12} xs={12}>
                        <Text type="regular" color="dark" weight={500}>
                          Endereço do destino:{' '}
                        </Text>
                        <Text type="regular" color="dark" weight={400}>
                          {formatAddress({
                            address: destination?.address,
                            number: destination?.number,
                            complement: destination?.complement,
                            neighborhood: destination?.neighborhood,
                            city: destination?.city,
                            province: destination?.province,
                            zip_code: destination?.zipCode,
                          })}
                        </Text>
                      </Col>
                    </>
                  )
                }
              </Row>
            </Col>
            <Col xxl={4} xl={5} lg={5} md={5} sm={12} xs={12}>
              <Row>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  {show.addDescriptionToOccurrence || show?.endOccurrence ? (
                    <DatePicker
                      label="Início ocorrência *"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      withTime
                      error={errors?.startDate}
                      disabled={loadingUpdate || savingNewOccurrence}
                    />
                  ) : (
                    <DatePicker
                      disabled
                      value={formatDateTime(selectedOccurrence.startDate)}
                      label="Início Ocorrência"
                      withTime
                    />
                  )}
                </Col>
                <Col xxl={6} lg={6} md={6} sm={12} xs={12}>
                  {show.addDescriptionToOccurrence || show.endOccurrence ? (
                    <DatePicker
                      label="Término ocorrência"
                      value={endDate || ''}
                      onChange={(e) => setEndDate(e.target.value)}
                      withTime
                      error={errors?.endDate}
                      disabled={loadingUpdate || savingNewOccurrence}
                    />
                  ) : (
                    <DatePicker
                      placeholder=""
                      disabled
                      value={formatDateTime(selectedOccurrence.endDate)}
                      label="Término Ocorrência"
                      withTime
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <AditionalFIeldsContainer>
            <Row>
              {show?.addDescriptionToOccurrence || show?.endOccurrence ? (
                <>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="A pagar ao transportador"
                      placeholder="Adicionar valor da ocorrência"
                      value={occurrenceValues?.payCarrier}
                      onChange={(_, value) => {
                        if (String(value)?.length > 11) {
                          return;
                        }
                        setOccurrenceValues({
                          ...occurrenceValues,
                          payCarrier: value
                        });
                      }}
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="A receber cliente"
                      placeholder="Adicionar valor da ocorrência"
                      value={occurrenceValues?.receiverClient}
                      onChange={(_, value) => {
                        if (String(value)?.length > 11) {
                          return;
                        }
                        setOccurrenceValues({
                          ...occurrenceValues,
                          receiverClient: value
                        });
                      }}
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="Retido filial"
                      placeholder="Adicionar valor da ocorrência"
                      value={occurrenceValues?.retainedBranch}
                      onChange={(_, value) => {
                        if (String(value)?.length > 11) {
                          return;
                        }
                        setOccurrenceValues({
                          ...occurrenceValues,
                          retainedBranch: value
                        });
                      }}
                    />
                  </Col>
                </>
              ) : (
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="A pagar ao transportador"
                      value={formatCurrency(selectedOccurrence.payCarrier)}
                      disabled
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="A receber cliente"
                      value={formatCurrency(selectedOccurrence.receiverClient)}
                      disabled
                    />
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="Retido filial"
                      value={formatCurrency(selectedOccurrence.retainedBranch)}
                      disabled
                    />
                  </Col>
                </Row>
              )}
              {
                selectedOccurrence?.value && (
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <InputCurrency
                      label="Valor"
                      value={formatCurrency(selectedOccurrence.value)}
                      disabled
                    />
                  </Col>
                )
              }
              <OccurencesAditionalFieldsContainer />
            </Row>
          </AditionalFIeldsContainer>
        </DetailsContainer>
      </SectionContainer>
      <Modal
        backdropClassName="backdrop-occurrences-aditional-field"
        show={aditionalItensModal.isOpen}
        handleClose={handleCloseModal}
        heading={<HeadingAditionalFieldModal />}
        body={<BodyAditionalFieldModal />}
        footer={<FooterAditionalFieldModal />}
      />
    </>
  );
}
